// @ts-strict-ignore
import * as React from 'react';
import { ButtonReact } from 'common/components/button';
import { ButtonTheme } from 'common/components/button/constants';
import { TooltipReact } from 'common/components/tooltip';
import { DisplaySize, Placement } from 'common/components/tooltip/types';
import { useTranslation } from 'common/i18n/hooks';
import { TemplateEntryPointPath, WarningHeroReportName, WarningHeroTheme } from './constants';
import { WarningHeroReact } from './index';
export function EmptyDashboardAddReportHeroTextCards(_ref) {
  let {
    children
  } = _ref;
  return <WarningHeroReact headerText={"Add a new chart, text or use a template to get started."} report={WarningHeroReportName.Dashboards} theme={WarningHeroTheme.EmptyReport} data-sentry-element="WarningHeroReact" data-sentry-component="EmptyDashboardAddReportHeroTextCards" data-sentry-source-file="presets-react.tsx">
      {children}
    </WarningHeroReact>;
}
export function EmptyDashboardCreateHero(_ref2) {
  let {
    onCreateDashboardClick,
    onOpenFoundationalTemplateModalClicked,
    headerText = "",
    bodyText = ""
  } = _ref2;
  const {
    t
  } = useTranslation();
  return <WarningHeroReact bodyText={bodyText} headerText={headerText || t("warning-hero.empty-board.header-text")} report={WarningHeroReportName.Dashboards} theme={WarningHeroTheme.EmptyReport} data-sentry-element="WarningHeroReact" data-sentry-component="EmptyDashboardCreateHero" data-sentry-source-file="presets-react.tsx">
      <div>
        <ButtonReact elref={"emptyCreateDashboardButton"} theme={ButtonTheme.Primary} onClick={onCreateDashboardClick} data-sentry-element="ButtonReact" data-sentry-source-file="presets-react.tsx">
          {t("warning-hero.empty-board.board-new")}
          <TooltipReact placement={Placement.Bottom} size={DisplaySize.Medium} text={t("warning-hero.empty-board.board-tooltip")} data-sentry-element="TooltipReact" data-sentry-source-file="presets-react.tsx" />
        </ButtonReact>
        <ButtonReact className={".foundational-template-add-button"} elref={"foundationalTemplateAddButton"} style={{
        marginLeft: "10px"
      }} theme={ButtonTheme.Secondary} onClick={() => onOpenFoundationalTemplateModalClicked({
        entryPoint: TemplateEntryPointPath.FirstDashboard
      })} data-sentry-element="ButtonReact" data-sentry-source-file="presets-react.tsx">
          {t("warning-hero.empty-board.template-new")}
        </ButtonReact>
      </div>
    </WarningHeroReact>;
}